function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import icWarning from 'assets/svg/ic_warning_2.svg';
import icError from 'assets/svg/ic_error_2.svg';
import styles from './styles.module.scss';
import { useTestId } from '@wolffun/testable-id';

const ErrorMessage = ({
  className,
  title,
  description,
  warning
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(className, styles.container, warning && styles.warning)
  }, generateTestIdProps('error')), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, !title && /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: warning ? icWarning : icError
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, !!title && /*#__PURE__*/React.createElement("div", {
    className: styles.titleContainer
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: warning ? icWarning : icError
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, title)), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, description))));
};

export default ErrorMessage;